/**
 * Labstep
 *
 * @module components/EntityStateWorkflow/Action/Create
 * @desc Create Action
 */

import EntityActionCreate from 'labstep-web/components/Entity/Action/Create';
import { EntityStateWorkflow } from 'labstep-web/models/entity-state-workflow.model';
import type React from 'react';
import type { EntityStateWorkflowActionCreateProps } from './types';

export const EntityStateWorkflowActionCreate: React.FC<
  EntityStateWorkflowActionCreateProps
> = ({ group }) => (
  <EntityActionCreate
    entityName={EntityStateWorkflow.entityName}
    body={{
      target_entity_class: 'ExperimentWorkflow',
      group_id: group.guid,
    }}
    redirectRoute={({ response }) => ({
      to: 'entity_state_workflow_show',
      params: { id: response.result },
    })}
    actionComponentProps={{
      type: 'button',
    }}
  />
);
